<nb-list>
  <nb-list-item class="item" *ngFor="let item of cardData; trackBy: trackByDate">
    <span>{{ item.paymentDatePtBr }}</span>
    <span>{{ item.productName }}</span>
    <span> {{item.amountLocal}}</span>
  </nb-list-item>
</nb-list>